export default "__VITE_ASSET__CeojyXFY__"